import { render } from "./Media.vue?vue&type=template&id=38d2c2c8"
import script from "./Media.vue?vue&type=script&lang=js"
export * from "./Media.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/sections/modules/Media.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38d2c2c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38d2c2c8', __exports__)) {
    api.reload('38d2c2c8', __exports__)
  }
  
  module.hot.accept("./Media.vue?vue&type=template&id=38d2c2c8", () => {
    api.rerender('38d2c2c8', render)
  })

}


export default __exports__